module.exports = __webpack_public_path__ + "img/home_top.d1de090b.jpg";